import { render } from "./AdminSubscriptions.vue?vue&type=template&id=542ea670&scoped=true&bindings={\"subscriptions\":\"data\",\"basicSubscriptions\":\"data\",\"getSubscriptions\":\"options\",\"getAdditionalSubscriptions\":\"options\",\"getPrice\":\"options\",\"getDiscountCode\":\"options\"}"
import script from "./AdminSubscriptions.vue?vue&type=script&lang=js"
export * from "./AdminSubscriptions.vue?vue&type=script&lang=js"

import "./AdminSubscriptions.vue?vue&type=style&index=0&id=542ea670&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-542ea670"

export default script